import { useStoreState } from 'easy-peasy';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import CrisisAlertOutlinedIcon from '@mui/icons-material/CrisisAlertOutlined';

import { getOrgCode } from '../../helper/utils.helper';
import { initHelpline } from '../../helper/api.helper';
import { Button } from '@mui/material';

const Helpline = () => {
  const user = useStoreState((state) => state.user);
  const clientData = useStoreState((state) => state.clientData);
  const emailDomains = useStoreState((state) => state.emailDomains);
  const qualified = useStoreState((state) => state.qualified);
  const isEmailDomainVerified =
    user &&
    clientData &&
    emailDomains?.some((domain) =>
      [user.email, ...(clientData.verifiedEmails ?? [])].some((email) => email.endsWith(domain))
    );
  const isUserAuthenticated = !qualified || isEmailDomainVerified;
  const navigate = useNavigate();

  const initHelplineCall = async () => {
    if (!user.phoneNumber) {
      toast.error('Please add phone number in your Profile to initiate Helpline.');
      return;
    }
    if (isUserAuthenticated) {
      const orgCode = getOrgCode();
      toast.promise(
        initHelpline(orgCode)
          .then((res) => res.json())
          .then((res) => {
            if (res.status !== 'success') {
              throw Error(res.message);
            }
          }),
        {
          success: 'Helpline call initiated, Please wait for the phone call',
          loading: 'Initiating helpline call',
          error: (err) => `Failed to make helpline call: ${err.message}`
        }
      );
    } else {
      navigate('/register/verify-organisation-email');
    }
  };
  return (
    <div className="container">
      <div className="flex-container align-center">
        <CrisisAlertOutlinedIcon />
        <h4 className="header">Helpline</h4>
      </div>
      <p className="margin-top--sm">
        This helpline is for crisis situations only. If you are experiencing distress and need
        immediate support, click the button below to connect with a crisis counsellor. Once you
        initiate the request, you will receive a call from us on your registered mobile number.
      </p>
      <p className="margin-top--sm margin-bottom--md">
        Do NOT use this for regular counselling needs. Please book a session with an available
        therapist for non-urgent concerns.
      </p>
      <Button onClick={initHelplineCall} variant="contained">
        urgent care helpline
      </Button>
      <style jsx>{`
        .container {
          background-color: #ffcc02;
          padding: 25px;
        }
        .header {
          margin: 0px;
          margin-left: 10px;
        }
      `}</style>
    </div>
  );
};

export default Helpline;
